export const HOME = { emergentLink: "emergent-link" };

export const AUTH = {
  loginForm: "login-form",
  emailInput: "login-email-input",
  passwordInput: "login-password-input",
  submitBtn: "login-submit-btn",
  errorMsg: "login-error-msg",
  // UAT 2FA verification screen
  twoFAForm: "verify-2fa-form",
  twoFAError: "verify-2fa-error",
  twoFASubmit: "verify-2fa-submit-btn",
};

export const NAV = {
  sidebar: "sidebar-nav",
  dashboardLink: "nav-dashboard",
  setupStudioLink: "nav-setup-studio",
  eventsLink: "nav-events",
  customersLink: "nav-customers",
  adminLink: "nav-administration",
  logoutBtn: "nav-logout-btn",
  userInfo: "nav-user-info",
  tenantBadge: "nav-tenant-badge",
  // BATCH 1 — Business navigation additions
  leadsLink: "nav-leads",
  uatLink: "nav-uat-control",
  uatFeedbackBtn: "nav-uat-give-feedback",
};

export const SETUP = {
  studioHome: "setup-studio-home",
  domainCard: "setup-domain-card",
  domainStatus: "setup-domain-status",
  readinessPct: "setup-readiness-pct",
  validateBtn: "setup-validate-btn",
  submitApprovalBtn: "setup-submit-approval-btn",
  approveBtn: "setup-approve-btn",
  activateBtn: "setup-activate-btn",
  blockersList: "setup-blockers-list",
  validationResults: "setup-validation-results",
  dependenciesList: "setup-dependencies-list",
  statusHistory: "setup-status-history",
  overallReadiness: "setup-overall-readiness",
  activeDomainCount: "setup-active-domain-count",
};

export const EVENTS = {
  eventList: "events-list",
  eventCard: "event-card",
  createEventBtn: "create-event-btn",
  createEventForm: "create-event-form",
  eventTypeSelect: "event-type-select",
  legalEntitySelect: "legal-entity-select",
  operatingUnitSelect: "operating-unit-select",
  locationSelect: "location-select",
  submitEventBtn: "submit-event-btn",
  eventDetail: "event-detail",
};

export const ORG = {
  legalEntityList: "legal-entity-list",
  createLegalEntityBtn: "create-legal-entity-btn",
  operatingUnitList: "operating-unit-list",
  locationList: "location-list",
};

export const AUDIT = {
  auditList: "audit-trail-list",
  auditItem: "audit-item",
};

// ── Stage 01: ONE Engage ──────────────────────────────────────────────────

export const ENGAGE = {
  dashboard: "engage-dashboard",
  statsCard: "engage-stats-card",
  recentLeads: "engage-recent-leads",
  quickActions: "engage-quick-actions",
};

export const INBOX = {
  inquiryList: "inbox-inquiry-list",
  inquiryItem: "inbox-inquiry-item",
  processBtn: "inbox-process-btn",
  createInquiryBtn: "inbox-create-inquiry-btn",
  processingState: "inbox-processing-state",
};

export const LEADS = {
  leadList: "leads-list",
  leadRow: "lead-row",
  filterStatus: "leads-filter-status",
  filterQualification: "leads-filter-qualification",
  leadNumber: "lead-number",
  leadStatus: "lead-status",
  leadQualification: "lead-qualification",
};

export const LEAD_DETAIL = {
  header: "lead-detail-header",
  infoPanel: "lead-detail-info-panel",
  conversationPanel: "lead-detail-conversation",
  messageList: "lead-detail-message-list",
  draftBtn: "lead-detail-draft-btn",
  sendBtn: "lead-detail-send-btn",
  escalateBtn: "lead-detail-escalate-btn",
  assignOwnerBtn: "assign-owner-btn",   // P-ARC-01R: canonical name
  assignPocBtn:   "assign-owner-btn",   // backward compat alias (same element)
  claimLeadBtn:   "claim-lead-btn",
  addFollowUpBtn: "lead-detail-add-followup-btn",
  policyIndicator: "lead-detail-policy-indicator",
  draftArea: "lead-detail-draft-area",
  qualificationScore: "lead-detail-qualification-score",
};

export const FOLLOW_UPS = {
  list: "follow-ups-list",
  item: "follow-up-item",
  completeBtn: "follow-up-complete-btn",
  rescheduleBtn: "follow-up-reschedule-btn",
  overdueTab: "follow-ups-tab-overdue",
};

